import React from "react";
import { Link } from "react-router-dom";
import { TopNav } from "../../../components/Navbar/Webpages/TopNav";
import Footer from "../../../components/Layout/Footer";

// Icons
import { SiWebmoney } from "react-icons/si";
import { AiFillLock } from "react-icons/ai";
import { GiGreekTemple } from "react-icons/gi";
import { MdSupportAgent, MdGroups, MdArrowForward } from "react-icons/md";
import { BsCreditCardFill } from "react-icons/bs";

// Helper component for Glass Cards
const ServiceCard = ({ icon: Icon, title, description, delay }) => (
  <div
    className="group relative bg-white rounded-3xl p-8 shadow-lg border border-gray-100 hover:-translate-y-2 hover:shadow-xl hover:shadow-primary/10 transition-all duration-300 overflow-hidden"
    data-aos="fade-up"
    data-aos-delay={delay}
  >
    {/* Hover Accent */}
    <div className="absolute inset-0 bg-primary/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

    <div className="relative z-10">
      <div className="w-14 h-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center text-3xl mb-6 group-hover:scale-110 transition-transform duration-300">
        <Icon />
      </div>
      <h4 className="text-xl font-heading font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors">
        {title}
      </h4>
      <p className="text-gray-500 font-body leading-relaxed text-sm">
        {description}
      </p>
    </div>
  </div>
);

const About = () => {
  return (
    <div className="bg-white overflow-x-hidden selection:bg-primary/20 selection:text-primary">
      <TopNav />

      {/* --- HERO SECTION --- */}
      <div className="relative h-[45vh] min-h-[400px] flex items-center justify-center overflow-hidden">
        {/* 1. Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1639322537228-f710d846310a?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80"
            alt="FAQ Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* 2. FULL BLUE OVERLAY */}
        {/* 2. FULL PRIMARY OVERLAY */}
        <div className="absolute inset-0 bg-primary/90 mix-blend-multiply z-10"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent z-10"></div>

        {/* 3. Content */}
        <div className="relative z-20 container max-w-screen-xl mx-auto px-4 text-center mt-8">
          <span className="inline-block py-1 px-4 rounded-full bg-white/20 backdrop-blur-md border border-white/30 text-white text-xs font-heading font-bold tracking-widest uppercase mb-6">
            About Zam-chain Advanced investment
          </span>

          <h1 className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6 tracking-tight drop-shadow-sm">
            Financial Freedom <br />
            <span className="text-blue-100">Starts Here</span>
          </h1>

          <p className="font-body text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light leading-relaxed">
            We simplify investment processes for individuals and institutions
            alike, providing a secure path to growing your income.
          </p>
        </div>
      </div>

      {/* --- STORY / ABOUT SECTION --- */}
      <section className="py-20 md:py-28 relative">
        <div className="container max-w-screen-xl mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center">
            {/* Text Content */}
            <div data-aos="fade-right">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 leading-tight mb-6">
                Professionally engaged in <br />
                <span className="text-primary relative inline-block">
                  Finances & Trading
                  {/* Decorative underline */}
                  <svg
                    className="absolute w-full h-3 -bottom-1 left-0 text-primary/20 -z-10"
                    viewBox="0 0 100 10"
                    preserveAspectRatio="none"
                  >
                    <path
                      d="M0 5 Q 50 10 100 5"
                      stroke="currentColor"
                      strokeWidth="8"
                      fill="none"
                    />
                  </svg>
                </span>
              </h2>

              <div className="space-y-6 text-gray-600 text-lg font-body leading-relaxed">
                <p>
                  Zam-chain Advanced Investment. is an investment business
                  platform developed under the control of an experienced team of
                  highly qualified financial experts and professional traders
                  for private highly profitable online investments.
                </p>
                <p>
                  We are very proud to state that our clientele base cuts across
                  financial institutions, individuals, and several other
                  corporate institutions. We are determined to provide the best
                  service to our clients.
                </p>
              </div>

              <div className="mt-10">
                <Link to="/register">
                  <button className="font-heading group flex items-center gap-2 bg-primary text-white px-8 py-4 rounded-full font-bold transition-all shadow-lg shadow-primary/30 hover:shadow-primary/50 hover:scale-105 hover:brightness-110">
                    Get Started Now
                    <MdArrowForward className="group-hover:translate-x-1 transition-transform" />
                  </button>
                </Link>
              </div>
            </div>

            {/* Image Side - WITH BRANDED OVERLAY */}
            <div className="relative group" data-aos="fade-left">
              {/* Decorative Border Offset */}
              <div className="absolute top-6 -right-6 w-full h-full border-2 border-primary/20 rounded-[2.5rem] -z-10 hidden md:block transition-transform duration-500 group-hover:translate-x-2 group-hover:-translate-y-2"></div>

              {/* Image Container with Rounding and Shadow */}
              <div className="relative rounded-[2rem] overflow-hidden shadow-2xl h-[500px]">
                {/* 1. The Image */}
                <img
                  src="/img/home/kanchanara-zy9m4doArXk-unsplash (1).jpg"
                  alt="Financial Growth"
                  className="w-full h-full object-cover transform transition-transform duration-700 group-hover:scale-110"
                />

                {/* 2. THE BRAND OVERLAY (Matching Hero) */}
                {/* primary/60 with mix-blend-multiply creates that rich brand tint */}
                <div className="absolute inset-0 bg-primary/60 mix-blend-multiply z-10 transition-opacity duration-500 group-hover:opacity-80"></div>

                {/* 3. Gradient for Depth */}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/90 via-transparent to-transparent z-10 opacity-80"></div>
              </div>

              {/* Floating Badge */}
              <div className="absolute -bottom-6 -left-6 z-20 bg-white p-5 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-4">
                <div className="bg-green-100 p-3 rounded-full text-green-600">
                  <MdGroups className="text-2xl" />
                </div>
                <div>
                  <p className="text-xs text-gray-400 uppercase font-heading font-bold tracking-wider">
                    Trusted By
                  </p>
                  <p className="text-xl font-heading font-bold text-gray-900">
                    340k+ Users
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --- SERVICES SECTION --- */}
      <section className="py-24 bg-gray-50 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: "radial-gradient(#444 1px, transparent 1px)",
            backgroundSize: "32px 32px",
          }}
        ></div>

        <div className="container max-w-screen-xl mx-auto px-4 relative z-10">
          <div className="text-center max-w-3xl mx-auto mb-16">
            <span className="text-primary font-heading font-bold tracking-wider uppercase text-sm">
              What We Offer
            </span>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-gray-900 mt-2 mb-6">
              Our Premium <span className="text-primary">Services</span>
            </h2>
            <p className="text-lg text-gray-500 font-body font-light">
              We have prepared investment solutions for clients with various
              financial capabilities. Find the service that perfectly meets your
              requirements.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ServiceCard
              icon={GiGreekTemple}
              title="Legal Company"
              description="Zam-chain Advanced Investment. is a fully registered legal company in London, operating under strict financial regulations."
              delay="0"
            />
            <ServiceCard
              icon={AiFillLock}
              title="Secure Control Panel"
              description="Our website utilizes state-of-the-art encryption and a user-friendly UX/UI to ensure your data is safe."
              delay="100"
            />
            <ServiceCard
              icon={SiWebmoney}
              title="Global Investments"
              description="We provide the best investment plans available globally, tailored to maximize returns for our partners."
              delay="200"
            />
            <ServiceCard
              icon={MdSupportAgent}
              title="24/7 Support"
              description="Our dedicated customer service team is available round the clock to resolve any issues instantly."
              delay="300"
            />
            <ServiceCard
              icon={BsCreditCardFill}
              title="Instant Payments"
              description="Withdrawals are processed automatically and funds are sent to your user wallet without delay."
              delay="400"
            />
            <ServiceCard
              icon={MdGroups}
              title="Affiliate Program"
              description="Grow with us. Earn 5% - 3% - 1% rewards by inviting friends and family to our affiliate program."
              delay="500"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
